<template >
    <div id="box">
        <div style="margin-top: 20px">
        <span style="margin-left: 30px;font-size: 16px"> 客户信息:  </span>
        <el-input v-model="input" placeholder="客户姓名、客户电话、客户店铺名称" style="width: 300px;
         margin-left: 10px"></el-input>
            <span style="margin-left: 30px;font-size: 16px;"> 所属区域:  </span>
            <el-form ref="form" :model="form" label-width="100px" style="width: 200px;float: right;
            margin-right: 390px">
                <el-cascader
                        :options="CityInfo"
                        v-model="form.selectedOptions"
                        @change="handleChange"
                >
                </el-cascader>
            </el-form>
            <el-button type="primary" icon="el-icon-search" style="position: absolute;right: 280px;top:21px;
            font-size: 12px" @click="search()">搜索</el-button>
            <el-button type="info" style="position: absolute;right: 150px;top:21px;
            font-size: 12px" icon="el-icon-delete" @click="empty()">清空</el-button>
        </div>
        <el-button type="primary" style="margin-left: 30px;margin-top: 10px"
                   @click="addForm">新增客户账户余额</el-button>
        <!--表格部分-->
        <template>
            <el-table
                    :data="tableData"
                    border
                    style="width: 95%;margin-left: 30px;margin-top: 15px;">
                <el-table-column
                        prop="name"
                        label="客户姓名"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="mobile"
                        label="客户电话"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="shopName"
                        label="客户店铺"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="area"
                        label="所属区域"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="balance"
                        label="账户总余额"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="最近入账时间"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="createBy"
                        label="入账人"
                        width="auto">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button plain
                                   size="mini"
                                   type="primary"
                                   @click="func(scope.row.id)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;margin-right: 30px;">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>
        </template>  <!--表格部分结束-->
        <!--新增弹出框-->
        <el-dialog title="新增客户账户余额" :visible.sync="add" :before-close="handleClose">
            <el-form  :inline="true" >
                <el-form-item label="客户手机:" style="margin-left: 20px" >
                    <el-input v-model="mobile" style="width: 230px" @change="getShopId()"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名:" style="margin-left: 20px" >
                    <el-input v-model="name" style="width: 230px" :disabled="true"></el-input>
                </el-form-item>
            </el-form>

            <el-form  :inline="true" >
                <el-form-item label="客户店铺:" style="margin-left: 20px" >
                    <el-input v-model="store" style="width: 230px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户区域:" style="margin-left: 20px" >
                    <el-input v-model="address" style="width: 230px" :disabled="true"></el-input>
                </el-form-item>

                <!--<el-form-item label="客户区域:" style="margin-left: 20px">-->

                <!--<el-form ref="form2" :model="form2" label-width="100px" style="width: 230px;float: right">-->
                    <!--<el-cascader-->
                            <!--:options="CityInfo"-->
                            <!--v-model="form2.selectedOptions"-->
                            <!--@change="AddhandleChange"-->
                    <!--&gt;-->
                    <!--</el-cascader>-->
                <!--</el-form>-->
                <!--</el-form-item>-->
            </el-form>

            <el-form  :inline="true" >
                <el-form-item label="入账金额:" style="margin-left: 20px" >
                    <el-input v-model="money" style="width: 450px" @change="addMoney()"></el-input>
                </el-form-item>
            </el-form>
            <span style="margin-left: 20px">请上传客户入账凭证:</span>
            <el-upload :multiple="true" action="#" accept="image/jpeg,image/gif,image/png,image/bmp"
                       :file-list="fileList" :http-request="fnUploadBusinessRequest" :show-file-list="false">
                <div v-if="'' != businessLicense" class="el-upload el-upload--picture-img">
                    <img v-for="src of businessLicense" :src="src" style="width: 200px;"/>
                </div>
                <div v-else class="el-upload el-upload--car-two">
                    <i
                            class="el-icon-plus"></i>
                </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>

            <el-form  :inline="true" style="margin-top: 20px" >
                <el-form-item label="客户账户总金额:" style="margin-left: 20px" >
                    <el-input v-model="totalMoney" style="width: 450px" :disabled="true"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="addClose">重 置</el-button>
                <el-button type="primary" @click="addSure">确 定</el-button>
                <el-button type="success" style="display: none"><a :href="download"
                                              download="测试">
                    导入请先下载模板</a></el-button>
                <el-button type="success" style="display: none">
                    <input type="file" @change="importf(this)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
                </el-button>
            </div>
        </el-dialog> <!--新增弹出框结束-->
        <!--第一个查看弹出框-->
        <el-dialog
                title="客户账户余额入账记录"
                :visible.sync="oneLook"
                width="40%"
                >
            <div style="margin-bottom: 20px">
                <span style="margin-right: 10px">2019-10-01</span>
                <span style="margin-right: 10px">18:00</span>
                <span style="margin-right: 10px">薛俊</span>
                <span style="margin-right: 10px">入账</span>
                <span style="margin-right: 10px">3000</span>
                <span style="color: skyblue;float: right;cursor: pointer" >查看入账详情</span>
            </div>
        </el-dialog>
        <!--查看弹出框-->
        <el-dialog title="客户账户余额入账详情" :visible.sync="details">
            <el-form :model="detailsData">
                <el-form-item label="客户电话:">
                    <el-input v-model="detailsData.mobile" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名:">
                    <el-input v-model="detailsData.name" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户店铺:">
                    <el-input v-model="detailsData.shopName" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户区域:">
                    <el-input v-model="detailsData.area" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户入账金额:">
                    <el-input v-model="detailsData.recordedMoney" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="客户账户总金额:">
                    <el-input v-model="detailsData.totalBalance" style="width: 500px" :disabled="true"></el-input>
                </el-form-item>
                <div>客户入账凭证:</div>
                <img :src="item" style="width: 200px;
                height: 200px;margin-left: 20px;margin-top: 20px" v-for="(item,index) in src">
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="success" @click="getPdf()" style="display: none">导出PDF</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import CityInfo from "@/plug-in/city-picker/city-data.js";
    import html2Canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    import { findBalanceList } from "@/api/salesCloud/balance";
    import { addBalanceList } from "@/api/salesCloud/balance";
    import { findMobileShop } from "@/api/salesCloud/balance";
    import { findUserBalance } from "@/api/salesCloud/balance";
    import { findAliToken } from "@/api/salesCloud/balance";
    import {details,calculatedBalance} from "@/api/salesCloud/checkDetail"
    import {DIC} from "@/const/dic";
    import {getAliyunPublicToken} from "@/api/oss/aliyun";
    import { formatterTime } from '@/util/util';
    import oss from 'ali-oss';
    import md5 from 'js-md5';

    export default {
        name: "index",
        data(){
            return {
                form: {
                    city : '',
                    erae : '',
                    minerae : '',
                    selectedOptions: [],//地区筛选数组
                },
                form2: {
                    city : '',
                    erae : '',
                    minerae : '',
                    selectedOptions: [],//地区筛选数组
                },
                city:"",
                erae:"",
                minerae:"",

                addCity:"",
                addErae:"",
                addMinerae:"",

                CityInfo:[],
                input:'',   //搜索输入框绑定数据
                currentPage1:1,     //默认显示第几页
                add: false,   //新增显示
                details:false,  //详情显示
                dialogImageUrl: '',
                dialogVisible: false,
                tableData:[

                ],
                    mobile:'',
                    name:'',
                    store:'',
                    area:'',
                    address:'',
                    money:'',
                    totalMoney:'',
                    totalMoney1:0,
                    shopID:'',
                    uploadImg:[],       //上传存放图片名字的数组
                    fileList:[],        //上传存放图片显示的数组
                    businessLicense: [], //存放服务器图片数组
                    fileList2:[         //查看存放图片显示的数组

                    ],
                detailsData:[],
                htmlTitle:'测试',
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 ,
                src:'',
                download:'./../../../downloadFile/客户账户余额模板.xlsx',
                oneLook:false,
            }
        },
        created(){
            this.CityInfo=CityInfo;
            // let page=this.currentPage;
            // let size=this.pageSize;
            let parmas = {
                page: this.currentPage,
                size: this.pageSize,
                name:this.input,
                mobile:this.input,
                shopName:this.input,
                province:this.city,
                city:this.erae,
                area:this.minerae,
            };

            findBalanceList(parmas).then((res) => {
                let data = JSON.parse(res.data);
                console.log(data);
                // for(let i=0;i<data.rows.length;i++){
                //     calculatedBalance(data.rows[i].id).then((res) => {
                //         data.rows[i].balance = res.data
                //         //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                //     })
                //
                // }
                this.total=data.total;
                this.tableData=data.rows;
                for(let i=0;i<this.tableData.length;i++){
                    this.tableData[i].createTime= formatterTime(this.tableData[i].createTime)
                }
                console.log("商品："+JSON.stringify(this.tableData))
                function getLocalTime(nS) {
                    let date = new Date(nS);
                    let  Y = date.getFullYear() + '-';
                    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                    let  D = date.getDate() + ' ';
                    let  h = date.getHours() + ':';
                    let  m = date.getMinutes() + ':';
                    let  s = date.getSeconds();
                    return Y+M+D+h+m+s;
                }
                for(let i=0;i<data.rows.length;i++){
                    data.rows[i].createTime=getLocalTime(data.rows[i].createTime);
                }
                for(let i=0;i<data.rows.length;i++){
                    data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                }
            });

        },
        methods:{
            //第一个查看
            look(i,data){
                this.oneLook=true;
            },
            //导入excel
            importf(obj) {
                let _this = this;
                let inputDOM = this.$refs.inputer;   // 通过DOM取文件数据
                this.file = event.currentTarget.files[0];
                var rABS = false; //是否将文件读取为二进制字符串
                var f = this.file;
                var reader = new FileReader();
                //if (!FileReader.prototype.readAsBinaryString) {
                FileReader.prototype.readAsBinaryString = function(f) {
                    var binary = "";
                    var rABS = false; //是否将文件读取为二进制字符串
                    var pt = this;
                    var wb; //读取完成的数据
                    var outdata;
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        var bytes = new Uint8Array(reader.result);
                        var length = bytes.byteLength;
                        for(var i = 0; i < length; i++) {
                            binary += String.fromCharCode(bytes[i]);
                        }
                        var XLSX = require('xlsx');
                        if(rABS) {
                            wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
                                type: 'base64'
                            });
                        } else {
                            wb = XLSX.read(binary, {
                                type: 'binary'
                            });
                        }
                        // outdata就是你想要的东西 excel导入的数据
                        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                        // excel 数据再处理
                        let arr = []
                        outdata.map(v => {
                            let obj = {}
                            obj.mobile = v.客户手机
                            obj.area = v.客户区域
                            obj.money = v.入账金额
                            arr.push(obj)
                        })
                        _this.accountList = [...arr];
                        console.log( _this.accountList[0]);
                        _this.mobile=_this.accountList[0].mobile;
                        _this.money=_this.accountList[0].money;
                        _this.reload();
                    }
                    reader.readAsArrayBuffer(f);
                }
                if(rABS) {
                    reader.readAsArrayBuffer(f);
                } else {
                    reader.readAsBinaryString(f);
                }
            },
            //上传
            async fnUploadBusinessRequest(option) {
                this.tableLoading = true;
                getAliyunPublicToken().then((res) => {
                    let data = JSON.parse(res.data);
                   // console.log(data);
                    let client = new oss({
                        region: data.point,
                        endPoint: data.point,
                        accessKeyId: data.accessKeyId,
                        accessKeySecret: data.accessKeySecret,
                        Expiration: data.expiration,
                        bucket: data.bucketName,
                        stsToken: data.securityToken
                    });
                    const storeAs = md5(option.file.name);
                    client.multipartUpload(storeAs, option.file, {
                    }).then(results => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs
                            file.value = url
                            files.push(file)
                        }
                        this.fileList = files
                        let array= results.res.requestUrls[0].split("?")
                        this.businessLicense.push(array[0])
                        this.tableLoading = false
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            //打印pdf
             getPdf(name) {
                     let shareContent = document.body,//需要截图的包裹的（原生的）DOM 对象
                         width = shareContent.clientWidth, //获取dom 宽度
                         height = shareContent.clientHeight, //获取dom 高度
                         canvas = document.createElement("canvas"), //创建一个canvas节点
                         scale = 4; //定义任意放大倍数 支持小数
                     canvas.width = width * scale; //定义canvas 宽度 * 缩放
                     canvas.height = height * scale; //定义canvas高度 *缩放
                     canvas.style.width = shareContent.clientWidth * scale + "px";
                     canvas.style.height = shareContent.clientHeight * scale + "px";
                     canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                     let opts = {
                         scale: scale, // 添加的scale 参数
                         canvas: canvas, //自定义 canvas
                         logging: false, //日志开关，便于查看html2canvas的内部执行流程
                         width: width, //dom 原始宽度
                         height: height,
                         useCORS: true, // 【重要】开启跨域配置
                     };

                     html2Canvas(shareContent, opts).then(() => {
                         var contentWidth = canvas.width;
                         var contentHeight = canvas.height;
                         //一页pdf显示html页面生成的canvas高度;
                         var pageHeight = (contentWidth / 592.28) * 841.89;
                         //未生成pdf的html页面高度
                         var leftHeight = contentHeight;
                         //页面偏移
                         var position = 0;
                         //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                         var imgWidth = 595.28;
                         var imgHeight = (592.28 / contentWidth) * contentHeight;
                         var pageData = canvas.toDataURL("image/jpeg", 1.0);
                         var PDF = new JsPDF("", "pt", "a4");
                         if (leftHeight < pageHeight) {
                             PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                         } else {
                             while (leftHeight > 0) {
                                 PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                                 leftHeight -= pageHeight;
                                 position -= 841.89;
                                 if (leftHeight > 0) {
                                     PDF.addPage();
                                 }
                             }
                         }
                         PDF.save('测试' + ".pdf"); // 这里是导出的文件名
                     });
             },
            dataURLToBlob(dataurl) {//ie 图片转格式
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime})
            },
            downloadResult(name) {
                let canvasID = document.body
                let a = document.createElement('a');
                html2Canvas(canvasID).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = "none";
                    a.style.display = "none";
                    document.body.removeChild(dom);
                    let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                    a.setAttribute("href", URL.createObjectURL(blob));
                    a.setAttribute("download", name + ".png")
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                });
            },
            printOut(name) {
                // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
                document.body.scrollTop = 0; // IE的
                document.documentElement.scrollTop = 0; // 其他
                this.downloadResult(name)
            },
            //搜索
            search(){
                let parmas = {
                    page: this.currentPage,
                    size: this.pageSize,
                    name:this.input,
                    mobile:this.input,
                    shopName:this.input,
                    province:this.city,
                    city:this.erae,
                    area:this.minerae,
                };
                findBalanceList(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    //console.log(data);
                    // for(let i=0;i<data.rows.length;i++){
                    //     calculatedBalance(data.rows[i].id).then((res) => {
                    //         data.rows[i].balance = res.data
                    //         //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                    //     })
                    //
                    // }
                    this.total=data.total;
                    // calculatedBalance(this.id).then((res) => {
                    //
                    //     //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                    // })
                    this.tableData=data.rows;
                    function getLocalTime(nS) {
                        let date = new Date(nS);
                        let  Y = date.getFullYear() + '-';
                        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                        let  D = date.getDate() + ' ';
                        let  h = date.getHours() + ':';
                        let  m = date.getMinutes() + ':';
                        let  s = date.getSeconds();
                        return Y+M+D+h+m+s;
                    }
                    for(let i=0;i<data.rows.length;i++){
                        data.rows[i].createTime=getLocalTime(data.rows[i].createTime);
                    }
                    for(let i=0;i<data.rows.length;i++){
                        data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                    }
                });

            },
            //清空
            empty(){
                this.input='';
                this.form.selectedOptions=[];
            },
            //点击去某一页
            handleCurrentChange(val) {
                this.currentPage=val;

                let parmas = {
                    page: this.currentPage,
                    size: this.pageSize,
                    name:this.input,
                    mobile:this.input,
                    shopName:this.input,
                    province:this.city,
                    city:this.erae,
                    area:this.minerae,
                };

                findBalanceList(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    //console.log(data);
                    // for(let i=0;i<data.rows.length;i++){
                    //     calculatedBalance(data.rows[i].id).then((res) => {
                    //         data.rows[i].balance = res.data
                    //         //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                    //     })
                    //
                    // }
                    this.total=data.total;
                    this.tableData=data.rows;
                    function getLocalTime(nS) {
                        let date = new Date(nS);
                        let  Y = date.getFullYear() + '-';
                        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                        let  D = date.getDate() + ' ';
                        let  h = date.getHours() + ':';
                        let  m = date.getMinutes() + ':';
                        let  s = date.getSeconds();
                        return Y+M+D+h+m+s;
                    }
                    for(let i=0;i<data.rows.length;i++){
                        data.rows[i].createTime=getLocalTime(data.rows[i].createTime);
                    }
                    for(let i=0;i<data.rows.length;i++){
                        data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                    }
                });
            },
            //查看详情
            show2(i,data){
                //console.log(i,data);
                this.fileList2=[];
                this.details=true;
                this.detailsData=data;
                let src=[];
                src=this.detailsData.recordedVoucher.split(',');
                console.log(src);
                this.src=src;
                for(let i=0;i<this.detailsData.length;i++){
                    this.detailsData.area=this.detailsData.province+this.detailsData.city+this.detailsData.area;
                }
            },
            addForm(){  //打开新增窗口
                this.address=''
                this.add=true;
            },
            //根据手机号获取店铺信息
            getShopId(){
                let mobile=this.mobile;
                findMobileShop(mobile).then((res) => {
                    let data = JSON.parse(res.data);
                    //console.log(data);
                    if(data!='' || data!= null){
                        //console.log(data.id);
                       this.name=data.name;
                       this.store=data.shopName;
                       this.shopID=data.id;
                       this.address=data.province+data.city+data.area
                        this.totalMoney=data.totalAmount
                        this.totalMoney1=data.totalAmount
                       //let shopId=data.id;
                        // findUserBalance(shopId).then((res) => {
                        //     let data = JSON.parse(res.data);
                        //     console.log(res);
                        //     if(data.rows[0]==[] || data.rows[0]==null || data.rows[0]==undefined){
                        //         this.totalMoney=0;
                        //     }else {
                        //         this.totalMoney=data.rows[0].totalBalance;
                        //     }
                        // })
                    }
                })
            },
            //确认新增
            addSure(){
                this.add=false;
                // console.log(this.mobile,this.name,this.store,this.area,this.money,this.totalMoney,this.addCity+this.addErae+
                // this.addMinerae,this.uploadImg,this.businessLicense);


                let addData={};
                addData.shopId=this.shopID;
                addData.vouchers=this.businessLicense;
                addData.amount=this.money;
                addData.totalAmount=this.totalMoney;
                addBalanceList(addData).then((res) => {
                    console.log(res);
                    if(res.code=='200' || res.code==200){
                        this.uploadImg=[];
                        this.fileList=[];
                        this.businessLicense=[];
                        this.mobile='';
                        this.name='';
                        this.store='';
                        this.area='';
                        this.money='';
                        this.totalMoney='';
                        this.shopID='';
                        this.form2.selectedOptions=[];
                        this.$message({
                            type: 'success',
                            message: '新增成功!',
                        });

                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name:this.input,
                            mobile:this.input,
                            shopName:this.input,
                            province:this.city,
                            city:this.erae,
                            area:this.minerae,
                        };

                        findBalanceList(parmas).then((res) => {
                            let data = JSON.parse(res.data);
                            //console.log(data);
                            // for(let i=0;i<data.rows.length;i++){
                            //     calculatedBalance(data.rows[i].id).then((res) => {
                            //         data.rows[i].balance = res.data
                            //         //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                            //     })
                            //
                            // }
                            this.total=data.total;
                            this.tableData=data.rows;
                            function getLocalTime(nS) {
                                let date = new Date(nS);
                                let  Y = date.getFullYear() + '-';
                                let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                                let  D = date.getDate() + ' ';
                                let  h = date.getHours() + ':';
                                let  m = date.getMinutes() + ':';
                                let  s = date.getSeconds();
                                return Y+M+D+h+m+s;
                            }
                            for(let i=0;i<data.rows.length;i++){
                                data.rows[i].createTime=getLocalTime(data.rows[i].createTime);
                            }
                            for(let i=0;i<data.rows.length;i++){
                                data.rows[i].area=data.rows[i].province+data.rows[i].city+data.rows[i].area;
                            }
                        });

                    }else {
                        this.$message({
                            type: 'error',
                            message: '新增失败!请正确填写信息',
                        });
                        this.uploadImg=[];
                        this.fileList=[];
                        this.businessLicense=[];
                        this.mobile='';
                        this.name='';
                        this.store='';
                        this.area='';
                        this.money='';
                        this.totalMoney='';
                        this.shopID='';
                        this.form2.selectedOptions=[];
                    }
            });

            },
            //重置
            addClose(){
                this.fileList=[];
                this.uploadImg=[];
                this.businessLicense=[];
                this.mobile='';
                this.name='';
                this.store='';
                this.area='';
                this.money='';
                this.shopID='';
                this.totalMoney='';
                this.form2.selectedOptions=[];
            },
            handleClose(){ //X关闭新增框
                this.add=false;
                this.fileList=[];
                this.uploadImg=[];
                this.businessLicense=[];
                this.mobile='';
                this.name='';
                this.store='';
                this.area='';
                this.shopID='';
                this.money='';
                this.totalMoney='';
                this.form2.selectedOptions=[];
                this.$message({
                    type: 'info',
                    message: '取消!',
                });
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleChange(value) {
                this.form.city = this.form.selectedOptions[0];
                this.form.erae = this.form.selectedOptions[1];
                this.form.minerae = this.form.selectedOptions[2];
                this.getCity(value[0]);
                this.getErae(value[1]);
                this.getMinerae(value[2]);
                console.log(this.city+this.erae+this.minerae);
            },
            AddhandleChange(value) {
                this.form2.city = this.form2.selectedOptions[0];
                this.form2.erae = this.form2.selectedOptions[1];
                this.form2.minerae = this.form2.selectedOptions[2];
                this.getCity(value[0]);
                this.getErae(value[1]);
                this.getMinerae(value[2]);
                console.log(this.addCity+this.addErae+this.addMinerae);
            },
            uploadImgChange(file, fileList){  //上传图片change事件
                this.uploadImg.push(file.name);
                let arr=[];
                for(let i = 0;i< this.uploadImg.length;i++){
                    if(arr.indexOf(this.uploadImg[i]) < 0){
                        arr.push(this.uploadImg[i]);
                    }
                }
                this.uploadImg=arr;
            },
            uploadImgRemove(file){   //上传图片移除事件
                for (let i=0;i<=this.uploadImg.length;i++){
                    if(file.name == this.uploadImg[i]){
                        this.uploadImg.splice(i,1);
                    }
                }
            },
            getCity(value){
                for(let y in this.CityInfo){
                    if(this.CityInfo[y].value == value){
                        this.city = this.CityInfo[y].label;
                        this.addCity = this.CityInfo[y].label;
                        //省
                    }
                }
            },
            getErae(value){
                for(let y in this.CityInfo){
                    for(let z in this.CityInfo[y].children){
                        if(this.CityInfo[y].children[z].value == value && value!=undefined){
                            this.erae = this.CityInfo[y].children[z].label;
                            this.addErae = this.CityInfo[y].children[z].label;
                            //市
                        }
                    }
                }
            },
            getMinerae(value){
                for(let y in this.CityInfo){
                    for(let z in this.CityInfo[y].children){
                        for(let i in this.CityInfo[y].children[z].children){
                            if(this.CityInfo[y].children[z].children[i].value == value && value!=undefined){
                                this.minerae = this.CityInfo[y].children[z].children[i].label;
                                this.addMinerae = this.CityInfo[y].children[z].children[i].label;
                                //区
                            }
                        }
                    }
                }
            },
            addMoney(){
                 if(this.money==''){
                     this.money=0
                 }
                this.totalMoney=this.totalMoney1+parseFloat(this.money)
            },
        func (id){
            this.$router.push({ name: "客户账户余额入账记录", path: "/sales/balanceDetails" ,query:{ id:id}});
        }
        },

    }




</script>

<style scoped>
    #box{
        width: 98%;
        height: auto;
        background: white;
        margin-left: 10px;
        border-radius: 5px;
        overflow: hidden;
    }
    .el-scrollbar{
        height: 98%;
    }
    .add{
        display: inline-block;
        overflow: auto;
        width: 800px;
        height: 750px;
        vertical-align: middle;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        font-size: 18px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        text-align: left;
        backface-visibility: hidden;
        position: absolute;
        top: 5px;
        left: 10%;
        z-index: 99;
        padding:  20px;
    }
    .el-col-11{
        width: 100%;
    }
    .el-select{
        width:  100%;
    }
    .shade{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: black;
        opacity: 0.2;
        z-index: 99;
    }
    .close{
        position: absolute;
        top: 15px;
        right: 25px;
        padding: 0;
        border: none;
        outline: none;
        background: transparent;
        font-size: 16px;
        cursor: pointer;
        color: #b6b6b6;
    }
    .close:hover{
        color: #56a7b4;
    }
    .confirm{
        position: absolute;
        right: 15px;
        bottom: 15px;
    }

</style>